// extracted by mini-css-extract-plugin
export default {"chips":"THEvYthhkCcuLQwK2nc7"};